import { getCommonStorePartial } from '../../global-store/subjects/common';
import { COMMON_STATE_KEYS } from '../../global-store/subjects/common/initial-state';
import { getHeight, hideElement, isNodeInView, unHideElement } from '../../utils/dom-utils';
import { isLargeScreen } from '../../utils/mediaquery-utils';

const $content = document.querySelector('article');
const $outbrainSmartFeed = $content.querySelector('.j-outbrain');
const $lWrapper = document.querySelector('.l-wrapper');
const $globalNav = document.querySelector('.j-global-nav');
const $primaryTagNav = document.querySelector('.j-primary-tag');
const $sectionNav = document.querySelector('.j-section-nav-wrapper');
const $localNav = document.querySelector('.j-local-nav');
const $lastNav = $primaryTagNav || $sectionNav || $localNav;
const $tagSection = document.querySelector('.s-tag-section');

const globalNavHeight = getHeight($globalNav);
const allStickyNavHeight = $content.offsetTop - globalNavHeight;
const scrollableArea = window.outerHeight - allStickyNavHeight;

const ACCURACY_OFFSET = isLargeScreen() ? 50 : -100; // The higher it is, the faster the progress reaches 100%

/**
 * Inject as sibling of $lastNav
 */
const injectProgressBar = () => {
  if ($lastNav) {
    const $progressBar = document.createElement('div');
    $progressBar.className = 'c-reading-progress-bar';
    if (isLargeScreen()) {
      $lastNav.appendChild($progressBar);
    } else {
      // Inject as sibling of $lastNav on mobile
      $lastNav.parentNode.insertBefore($progressBar, $lastNav.nextSibling);
    }

    const $progressBarContent = document.createElement('div');
    $progressBarContent.className = 'c-reading-progress-bar__content';
    $progressBar.appendChild($progressBarContent);
    return [$progressBar, $progressBarContent];
  }
};

const checkProgress = ($progressBarContent) => {
  const outbrainHeight = getHeight($outbrainSmartFeed);
  const contentHeight = getHeight($content) - outbrainHeight + ACCURACY_OFFSET;
  const advOnTopHeight = $lWrapper.offsetTop;
  const pageYOffset = window.pageYOffset || document.documentElement.scrollTop;
  const currentTop = pageYOffset - advOnTopHeight - globalNavHeight;

  let progress = (currentTop / (contentHeight - scrollableArea)) * 100;
  // If the tag section div is in view --> move to 100%
  if (progress > 90 && progress < 100 && isNodeInView($tagSection)) {
    progress = 100;
  }

  // update progress bar style
  if (progress > 0) {
    $progressBarContent.style.width = progress > 100 ? '100%' : `${progress}%`;
  } else {
    $progressBarContent.style.width = 0;
  }
};

export const init = () => {
  // Inject progress bar
  const [$progressBar, $progressBarContent] = injectProgressBar();

  // Update progress bar
  window.addEventListener('scroll', () => checkProgress($progressBarContent));

  // Toggle depending on the HP injected
  const key = COMMON_STATE_KEYS.IS_INJECTED_HP_IN_VIEW;
  const injectedHPInViewStore = getCommonStorePartial(key);
  injectedHPInViewStore.subscribe((isInjectedHPInView) => {
    if (isInjectedHPInView) {
      hideElement($progressBar);
    } else {
      unHideElement($progressBar);
    }
  });
};
